module.exports = __webpack_public_path__ + "static/media/LogicWheel6_1_continue_2.4c6f62d1.png";